import { DropdownItem } from '@bybeam/platform-types';
import { Value } from 'classnames';

export const parseFieldValues = (
  valuePairs: {
    label: Value;
    value: Value;
    children?: { label: Value; value: Value }[];
  }[],
  value: Value,
  defaultValue: string,
): Value => {
  return (
    ((valuePairs as DropdownItem[]) ?? [])
      .flatMap((parent) => [
        parent,
        ...('children' in parent && parent.children ? parent.children : []),
      ])
      .find(({ value: v }) => String(v) === String(value))?.label || defaultValue
  );
};
